import React from "react";
import { Input, Text } from "@zorni/components-lib";
import { useTranslation } from "react-i18next";
import styles from "../PublishTrip.module.css";

const GeneralSettingsSection = ({
  tripReference,
  maxChildAge,
  maxBabyAge,
  onMaxChildAgeChange,
  onMaxBabyAgeChange,
}) => {
  const { t } = useTranslation();

  return (
    <div className={styles.section}>
      <Text as="h2" className={styles.sectionTitle} weight="semibold">
        {t("tripPublication.publishTrip.sections.general")}
      </Text>
      <div className={styles.grid3}>
        <div className={styles.formGroup}>
          <Input
            floatingLabel
            inputSize="medium"
            label={t("tripPublication.publishTrip.fields.tripReference")}
            name="tripReference"
            type="text"
            value={tripReference || ""}
            disabled
          />
        </div>
        <div className={styles.formGroup}>
          <Input
            floatingLabel
            inputSize="medium"
            label={t("tripPublication.publishTrip.fields.maxChildAge")}
            name="childAge"
            type="number"
            value={maxChildAge}
            onChange={(event) => onMaxChildAgeChange(event.target.value)}
          />
        </div>
        <div className={styles.formGroup}>
          <Input
            floatingLabel
            inputSize="medium"
            label={t("tripPublication.publishTrip.fields.maxBabyAge")}
            name="babyAge"
            type="number"
            value={maxBabyAge}
            onChange={(event) => onMaxBabyAgeChange(event.target.value)}
          />
        </div>
      </div>
    </div>
  );
};

export default GeneralSettingsSection;
